import { t } from 'i18next';
import { all, call, put, select, takeLatest } from 'redux-saga/effects';
import { getOrganizationSlug } from '../organizations/selectors';
import { getEdgeMarketsByOrg, getEdgeMarkets } from './data';
import { errorReceiveAllEdgeMarkets, errorReceiveEdgeMarkets, errorReceiveEdgeMarketsForOrg, failedReceiveEdgeMarkets, receiveEdgeMarkets } from './slice';
export function* requestEdgeMarkets(action) {
    try {
        const { consumerAPI } = action.payload;
        const organization = yield select(getOrganizationSlug);
        const [marketsByOrg, allMarkets] = yield all([call(getEdgeMarketsByOrg, organization, consumerAPI), call(getEdgeMarkets, consumerAPI)]);
        if (!marketsByOrg && !allMarkets) {
            throw new Error(t('NO_DATA_AVAILABLE', {
                ns: 'Common'
            }));
        }
        const { data: orgMarkets = [], error: orgError } = marketsByOrg;
        const { data: markets = [], error: error } = allMarkets;
        const edgeMarkets = {
            allMarkets: markets,
            orgMarkets
        };
        if (!consumerAPI) {
            if (error || orgError) {
                if (orgError && error) {
                    yield put(errorReceiveEdgeMarkets());
                }
                if (error && !orgError) {
                    yield put(errorReceiveAllEdgeMarkets(edgeMarkets));
                }
                else {
                    yield put(errorReceiveEdgeMarketsForOrg(edgeMarkets));
                }
            }
            else if (orgMarkets && markets) {
                yield put(receiveEdgeMarkets(edgeMarkets));
            }
        }
        else {
            if (marketsByOrg.status !== 200 && allMarkets.status !== 200) {
                yield put(errorReceiveEdgeMarkets());
            }
            else if (marketsByOrg.status !== 200) {
                yield put(errorReceiveEdgeMarketsForOrg(edgeMarkets));
            }
            else if (allMarkets.status !== 200) {
                yield put(errorReceiveAllEdgeMarkets(edgeMarkets));
            }
            else if (marketsByOrg.status === 200 && allMarkets.status === 200) {
                yield put(receiveEdgeMarkets(edgeMarkets));
            }
        }
    }
    catch (e) {
        yield put(failedReceiveEdgeMarkets());
    }
}
export function* watchRequestEdgeMarkets() {
    yield takeLatest('edgeMarkets/requestEdgeMarkets', requestEdgeMarkets);
}
